export default {
    getLabels: () => {
        return {
            url: '/groups/126/labels',
            method: 'GET',
        };
    },
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/data/Labels/api.js